import { render, staticRenderFns } from "./dyncTable.vue?vue&type=template&id=22eaec13&"
import script from "./dyncTable.vue?vue&type=script&lang=js&"
export * from "./dyncTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports